import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from '../components/dashboard/dashboard.component';
import { ParentsComponent } from '../components/parents/parents.component';
import { SignInComponent } from '../components/sign-in/sign-in.component';
import { YASComponent } from '../components/yas/yas.component';
import { AuthGuard } from '../guards/auth.guard';

const routes: Routes = [
	{ path: '', component: DashboardComponent },
	{ path: 'dashboard', component: DashboardComponent },
	{ path: 'yas/:id', component: YASComponent },
	{ path: 'parents/:id', component: ParentsComponent },
	{ path: 'sign-in', component: SignInComponent },
	{ path: '**', redirectTo: '/' },
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
	providers: [AuthGuard],
})
export class AppRoutingModule {}
